import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './workspace.scss';

function PageSurface({ children, className, footer, header, toolbar, ...rest }) {
  return (
    <div className={classnames('page-surface', className)} {...rest}>
      {header && <div className="page-surface__header">{header}</div>}
      {toolbar && <div className="page-surface__toolbar">{toolbar}</div>}
      <div className="page-surface__content">{children}</div>
      {footer && <div className="page-surface__footer">{footer}</div>}
    </div>
  );
}

PageSurface.defaultProps = {
  children: null,
  className: '',
  footer: null,
  header: null,
  toolbar: null
};

PageSurface.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  footer: PropTypes.node,
  header: PropTypes.node,
  toolbar: PropTypes.node
};

export { PageSurface };
